export default function Features() {
  return (
    <section id="features" className="relative bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-accent-400">
              <i className="ri-sparkling-2-line" aria-hidden="true"></i>
              核心服务
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-50">
              一站式语音娱乐体验
            </h2>
            <p className="mt-4 max-w-2xl text-foreground-300">
              从高清语音到互动直播，从开黑匹配到兴趣社区，歪歪把每一种热爱都连接在一起，让每一次开麦都有回响。
            </p>
          </div>
          <a
            href="#download"
            className="inline-flex items-center gap-2 self-start md:self-auto rounded-md border border-background-300/70 px-4 py-2.5 text-sm font-medium text-foreground-100 hover:border-primary-400/60 hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            了解客户端
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          <article className="relative flex min-h-[320px] md:row-span-2 overflow-hidden rounded-xl border border-background-200/70">
            <img
              src="https://readdy.ai/api/search-image?query=Group%20of%20young%20friends%20wearing%20headsets%20joyfully%20talking%20through%20a%20voice%20chat%20app%20in%20a%20cozy%20dark%20gaming%20room%20lit%20by%20warm%20amber%20and%20mint%20green%20neon%20glow%2C%20modern%20digital%20social%20scene%2C%20laughing%20and%20connecting%2C%20cinematic%20editorial%20photography%2C%20moody%20atmosphere%2C%20rich%20detail&width=1200&height=900&seq=yy-feature-voice&orientation=landscape"
              alt="高清语音连麦，好友在线畅快开麦"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent"></div>
            <div className="relative z-10 mt-auto p-5 md:p-6">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-voiceprint-fill text-xl" aria-hidden="true"></i>
              </span>
              <h3 className="mt-3 font-heading text-xl md:text-2xl text-foreground-50">高清语音连麦</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-300">
                低延迟、高清晰的语音通道，支持多路混音与降噪增强。无论开黑对局还是深夜畅聊，音质始终在线。
              </p>
            </div>
          </article>

          <article className="rounded-xl border border-background-200/70 bg-background-50 p-5 md:p-6">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-950">
              <i className="ri-gamepad-line text-xl" aria-hidden="true"></i>
            </span>
            <h3 className="mt-3 font-heading text-lg md:text-xl text-foreground-50">多人在线开黑</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-300">
              一键创建战队房间，房间码快速邀请好友，实时同步战况与语音，默契配合从不掉线。
            </p>
          </article>

          <article className="rounded-xl border border-background-200/70 bg-background-50 p-5 md:p-6">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-500 text-background-950">
              <i className="ri-live-line text-xl" aria-hidden="true"></i>
            </span>
            <h3 className="mt-3 font-heading text-lg md:text-xl text-foreground-50">高清互动直播</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-300">
              流畅的直播推流与实时弹幕互动，连麦打赏、礼物互动一应俱全，让每一次演出都有你的掌声。
            </p>
          </article>

          <article className="relative flex min-h-[220px] items-end overflow-hidden rounded-xl border border-background-200/70 md:col-span-3">
            <img
              src="https://readdy.ai/api/search-image?query=Colorful%20digital%20community%20hub%20concept%20with%20floating%20interest%20community%20cards%20about%20music%2C%20gaming%2C%20anime%20and%20esports%2C%20warm%20amber%20and%20mint%20green%20glowing%20accents%20on%20dark%20background%2C%20modern%20flat%20illustration%20style%2C%20energetic%20and%20friendly%2C%20high%20detail%20digital%20art&width=1600&height=500&seq=yy-feature-community&orientation=landscape"
              alt="兴趣频道社区，音乐、游戏、二次元与电竞聚集地"
              className="absolute inset-0 h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/40 to-transparent"></div>
            <div className="relative z-10 flex flex-col sm:flex-row sm:items-center gap-4 p-5 md:p-7">
              <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-disc-line text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-50">兴趣频道社区</h3>
                <p className="mt-1 text-sm text-foreground-200">
                  音乐、游戏、二次元、电竞……海量兴趣频道一键加入，总有一个地方能让你的热爱落地生根。
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}